// Turn a page element into an A4 PDF with the shared layout rules (web/src/pdflayout.ts): real pages, blocks and table
// rows never split, header and footer with "Page X of Y" on every page. Used by finance and landed cost reports, the
// help pages and other screen reports.
import { documentToPdf } from "./pdflayout.js";

export async function elementToPdf(el: HTMLElement, fileName: string, title: string, opts: { landscape?: boolean; subtitle?: string } = {}) {
  await documentToPdf(el, { title, subtitle: opts.subtitle, landscape: opts.landscape }, fileName);
}
